// The "Remove <member>?" text (People row menu; also meant for the Edit details drawer): everything team.delete
// unassigns, counted and named, so an admin can choose Active off (keeps their history) instead.
import { PIC_KEYS, plural } from '../../shared/constants.js';
import { isOpenBatch } from '../../shared/derive.js';

export function removalText(state, member, accounts) {
  const mine = (e) => e.owner === member.id;
  const open = state.batches.filter((b) => mine(b) && isOpenBatch(b)).length;
  const done = state.batches.filter((b) => mine(b) && !isOpenBatch(b)).length;
  const clients = state.clients.filter(mine).length;
  const pics = state.clients.reduce((n, c) => n + PIC_KEYS.filter((k) => c.pic?.[k] === member.id).length, 0);
  const events = state.events.filter(mine).length;
  const parts = [
    open && plural(open, 'open batch', 'open batches'),
    done && `${plural(done, 'completed batch', 'completed batches')} (their Performance history)`,
    clients && `${plural(clients, 'client')} they own`,
    pics && plural(pics, 'PIC slot'),
    events && plural(events, 'event'),
  ].filter(Boolean);
  const list = parts.length > 1 ? `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}` : parts[0];
  return [
    list && `Unassigns ${list}.`,
    accounts && 'They can no longer sign in.',
    list && member.active !== false && 'To keep their history, switch Active off instead.',
  ].filter(Boolean).join(' ') || 'They leave the team list.';
}
